import Swiper from "@modules/swiper";
import { Navigation, Pagination, A11y, Keyboard } from "@modules/swiper/modules";

// import '@modules/swiper/css';
// import "@modules/swiper/css/a11y";
// import "@modules/swiper/css/keyboard";
// import "@modules/swiper/css/navigation";
// import "@modules/swiper/css/pagination";
import $ from "@modules/jquery";
//console.log("GalleryBlock.js loaded");

var language = document.getElementsByTagName("html")[0].getAttribute("lang");
var SlideMessagePrev = language === "it" ? "Mostra immagine precedente" : "Vorheriges Bild anzeigen";
var SlideMessageNext = language === "it" ? "Mostra immagine successiva" : "Nächstes Bild anzeigen";

export default () => {
    // Inizializza le gallery
    const galleryBlocks = document.querySelectorAll(".gallery");
   
    galleryBlocks.forEach((galleryBlock) => {
        const swiperElement = galleryBlock.querySelector(".slider-gallery");

        if (swiperElement) {
            const swiper = new Swiper(swiperElement, {
                modules: [Navigation, Pagination, A11y, Keyboard],
                a11y: {

                    prevSlideMessage: SlideMessagePrev,
                    nextSlideMessage: SlideMessageNext,
                },
             
                slidesPerView: 1.6,
                slideToClickedSlide: true,
                spaceBetween: 15,
                centeredSlides: false,
                
               
                pagination: {
                    el: ".swiper-pagination",
                    type: "progressbar",
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                    pageUpDown: true,
                },
                grabCursor: true,
                navigation: {
                    prevEl: ".arrow-left",
                    nextEl: ".arrow-right",
                },
                breakpoints: {
                    640: {
                        slidesPerView: 2.4,
                        spaceBetween: 30,
                        centeredSlides: true,
                    },
                },
                on: {
                    init: function () {
                        toggleDidascalia(this);
                        positionArrowsInsideImage(this);
                    },
                    slideChange: function () {
                        toggleDidascalia(this);
                        positionArrowsInsideImage(this);
                    },
                },
            });

            // Gestione aria-hidden e tabindex
            swiper.on("slideChange", function () {
                const slides = swiper.slides;
                slides.forEach((slide, index) => {
                    slide.setAttribute("aria-hidden", index !== swiper.activeIndex);
                    slide.setAttribute("tabindex", index === swiper.activeIndex ? "0" : "-1");
                });
            });

            // Aggiorna la posizione delle frecce al resize della finestra
            window.addEventListener("resize", function () {
                positionArrowsInsideImage(swiper);
            });
        } else {
            console.warn("Elemento .swiper non trovato.");
        }
    });

    // Mostra/nasconde la didascalia nella slide attiva
    function toggleDidascalia(swiper) {
        document.querySelectorAll(".swiper-slide .didascalia").forEach((el) => {
            el.classList.remove("opacity-100", "transition-all", "duration-500", "ease-in-out");
            el.classList.add("opacity-0");
        });

        const activeSlide = swiper.slides[swiper.activeIndex];
        const didascalia = activeSlide.querySelectorAll(".didascalia");

        if (didascalia.length > 0) {
            didascalia[0].classList.remove("opacity-0");
            didascalia[0].classList.add("opacity-100", "transition-all", "duration-500", "ease-in-out");
            didascalia[0].id = `didascalia-${swiper.activeIndex}`;
            activeSlide.setAttribute("aria-describedby", `didascalia-${swiper.activeIndex}`);
            didascalia[0].setAttribute("aria-live", "assertive");
            didascalia[0].setAttribute("tabindex", "-1");
        }
    }

    // Posiziona le frecce in base all'immagine attiva
    function positionArrowsInsideImage(swiper) {
        const activeSlide = swiper.slides[swiper.activeIndex];
        const image = activeSlide.querySelector("img");
        const frecce = document.querySelector(".frecce_gallery");

        if (!image || !frecce || !activeSlide.classList.contains('swiper-slide-active')) return;

        // Se l'immagine non è ancora caricata, aspetta il load
        if (!image.complete) {
            image.addEventListener('load', () => positionArrowsInsideImage(swiper), { once: true });
            return;
        }

        const imageRect = image.getBoundingClientRect();
        const imageTop = 35;
        const imageHeight = imageRect.height;

        let newArrowPositionTop;
        if (window.innerWidth <= 768) {
            newArrowPositionTop = imageTop + imageHeight + 35;
        } else if (window.innerWidth <= 1024) {
            newArrowPositionTop = imageTop + imageHeight + 30;
        } else if (window.innerWidth <= 1240) {
            newArrowPositionTop = imageTop + imageHeight - 28;
        } else {
            newArrowPositionTop = imageTop + imageHeight - 30;
        }

        frecce.style.top = `${newArrowPositionTop}px`;
    }

}